
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getData, resolveImage } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import Alcoholic from './alcoholic';
import Drinks from './drinks';
import DrinksHouse from './drinksHouse';
import CoffeShop from './coffeShop';

function Index({dishs, setShowListProduct, goHome}) { 

    const [showDrinks, setShowDrinks] = useState(false);
    
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

    const { menus: menusCurrent, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);
    const [showCocktails, setShowCocktails] = useState(false);

     const [showCategories, setshowCategories] = useState(false);
    const [titleCategorie, setIitleCategorie] = useState('');

    const [menusData, setMenusData] = useState([]);
     const [menus, setMenus] = useState(menusCurrent);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [Beverages, setBeverages] = useState(false);
    const [showDrinksHouse, setshowDrinksHouse] = useState(false);
    const [showCoffe, setshowCoffe] = useState(false);

     useEffect(() => {
            getData('menu').then((items) => {
                // Sin menu en disco todavia: no reventar la app entera.
                if (!items?.value?.data) return;
                const data = items.value.data;
                setMenusData(data);
            });
        }, []);

    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);

      useEffect(() => {
        menusData.map((item) => {
            
            if (item.id === 902) {
                setBeverages(item);
            }
        });
      }, [menusData]);
    
const GoBeverages = () => {
          console.log({Beverages});
         setMenus(Beverages.menus)
    }


    const fetchImage = async (id) => {
        return resolveImage(id);
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-h-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: '#721821', marginBottom: 30, textDecoration: 'none', 
                width: '100%',
                maxHeight: 450,
                margin: '0px 0px 15px',
                textAlign: 'left',
               
                paddingBottom: 20,
              
                boxSizing: 'border-box',
                position: 'relative',
                borderRadius: 15,
            }}>
                <img src={image}  style={{width: '100%', height: 240, objectFit: 'cover',    borderRadius: 10,}}/>
                <h3 style={
                    {  color: '#fff', textTransform: 'uppercase', fontSize: 24, margin: '10px 0 0', textAlign: 'left', fontFamily: 'Noodle', marginLeft: 15 }
                    }>
                    
                    {/* {data.name} */}
                    {langEng ? data.name : translate(i18n.language, data.language, data.name)}
                
                </h3>
                
                <div style={{width: '100%', margin: '0 auto'}}>
                    <p
                        className='shor-text-one'
                        style={{ fontFamily: "Noodle", fontSize: 18, color: '#fff', textAlign: 'left', margin: 0,  marginLeft: 15,textTransform: 'uppercase', fontWeight: '500'}}>

                        {/* {`${data.regular_decription.replace(/\\n/g,'\n')}`} */}
                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                        
                    </p>
                </div>
            </div>
        );
    }
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={() => {
              setShowDrinks(true)
        }} showCocktails={ setShowCocktails}  showLamp={ false}   showBack={true} showImageTop={false} goHome={goHome} setShowListProduct={setShowListProduct} setShowSpecials={setShowSpecials}>
                
                <div style={{
                   // backgroundImage: `url(${require('./assets/barra.png')})`,
                    background: '#721821',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: '94%',
                    margin: '0 auto',
                    display: 'flex',
                    padding: '12px 14px',
                    gap: 12,
                    justifyContent: 'flex-start',
                    overflowX: 'auto',
                    position: 'relative',
                    zIndex: 100,
                    borderRadius: 30
                }}>
                    {menusData.map((item, key) => {
                             if (![767, 444, 445, 446, 448, 449, 450, 429, 430, 425, 424, 555, 565, 564, 566, 567].includes(item.id)) {
                                return <div key={key} style={{  
                                    background: '#f9e5c8',
                                    display: 'flex',
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: '12px 28px',
                                    borderRadius: 25,
                                    minWidth: 'fit-content'
                            }}
                                    onClick={() => { 
                                    if(item.id === 902) {
                                     setShowDrinks(true)
                                    }if(item.id === 907) {
                                     setshowCoffe(true)
                                    } else {    
                                        setMenus(item.menus)
                                    }
                                }}
                                >
                                    <p className='shor-text' style={{ color: '#000', fontFamily: 'Noodle', fontSize: 27, margin: 0, textTransform: 'uppercase',  }}>
{/* {item.name} */}
                                        
                                    {langEng ?
                                    `${item.name}`
                                :
                                `${translateMenu(
                                    i18n.language,
                                    item.language,
                                    item.name,
                                    'name'
                                )}`
                                        }
                                    </p>

                            </div>
                            }
                            
                        })}
                </div>

             
                <div style={{ width: '100%', height: 100,  boxSizing: 'border-box', marginTop: 10, marginBottom: 10 }}>
                    <img src={require('./assets/sidescarnes.png')} style={{width: '100%', height: 120, objectFit: 'contain', borderRadius: 15}} />
                </div>
                <div >

                    <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        gap: 10,
                          paddingInline: 20
                       
                    }}>
                        <div style={{ width: '40%' , marginTop: 15,}}>
                            <img src={require('./assets/BANNERBEBIDAS.png')} style={{width: '100%', height: 580, objectFit: 'cover', borderRadius: 15}} />
                        </div>
                         <div style={{
                            width: '60%',
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'flex-start',
                            gap: '4%',
                            padding: '0px 0px 100px 0px',
                            maxHeight: 480,
                            overflowY: 'scroll',
                            marginTop: 15,
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                    </div>   
                    </div>
                   
                    
      

                
                
                </div>
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                {showDrinks && <Drinks setShowHappy={setShowDrinks} />}  
                {showDrinksHouse && <DrinksHouse setShowHappy={setshowDrinksHouse} />}
                {showCoffe && <CoffeShop setShowHappy={setshowCoffe} />}
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                {showCocktails && <Alcoholic setShowHappy={setShowCocktails} />}
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;